const rooster = {
  undoDelete: {
    // no op
  },
}

const tops = {
  undoDelete: {
    position: 'fixed',
    width: '336px',
    left: '50%',
    bottom: '0px',
    transform: 'translateX(-50%)',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Settings/styles/HelperDialogs.js